/** 试卷相关vuex
 * @author liuShuai
 * @date 2023/4/4 13:07
 */
const state = {
    // 查阅筛选条件
    consultCondition: {}
}

const mutations = {
    setConsultCondition: (state, value) => {
        state.consultCondition = value
    }
}

export default {
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/modules/testPaper.js